export default "__VITE_ASSET__CAPC06py__"